export default {
  data() {
    return {
      // ユーザーアイコンクリック時のサブメニュー
      submenus: [{
        name:  "submenus.owners",
        path:  "/owners",
        visibleToUser(user) {
          if(user.company) {
            return user.company.type === 'admin'
          }
          return false
        },
        line: false
      },{
        name:  'submenus.member',
        path:  "/member",
        visibleToUser(user) {
          if(user.company || user.role) {
            return user.company.type === 'admin'|| user.role === 'owner'
          }
          return false
        },
        line: false
      },{
        name:  "submenus.contract",
        path:  "/contract",
        visibleToUser(user) {
          return true;
        },
        line: false
      },{
        name:  "submenus.setting",
        path:  "/setting",
        visibleToUser(user) {
          return true;
        },
        line: false
      }],
      submenusForUser(user) {
        return this.submenus.filter(m => m.visibleToUser(user));
      }
    }
  }
}
